import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { buildPillSvgString } from "./pill-border-utils";
import { hyphenateSync as hyphenate } from "hyphen/de";

const injectPillBorders = (container, selectors) => {
  selectors.forEach((selector) => {
    container.querySelectorAll(selector).forEach((el) => {
      if (el.querySelector("[data-pill-border]")) return;
      const { width, height } = el.getBoundingClientRect();
      if (!width || !height) return;
      const fragment = document
        .createRange()
        .createContextualFragment(buildPillSvgString(width, height));
      fragment.firstChild.setAttribute("data-pill-border", "");
      el.style.position = "relative";
      el.insertBefore(fragment, el.firstChild);
    });
  });
};

const RichText = ({ html, className, pillSelectors = [], hyphenated }) => {
  const ref = useRef(null);

  useEffect(() => {
    // Keep a stable reference: the ResizeObserver callback may still fire
    // after unmount, when ref.current is already null.
    const container = ref.current;
    if (!container || !pillSelectors.length) return;
    injectPillBorders(container, pillSelectors);

    const observer = new ResizeObserver(() => {
      container
        .querySelectorAll("[data-pill-border]")
        .forEach((svg) => svg.remove());
      injectPillBorders(container, pillSelectors);
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, [html, pillSelectors]);

  return (
    <div
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{ __html: hyphenated ? hyphenate(html) : html }}
    />
  );
};

RichText.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  pillSelectors: PropTypes.arrayOf(PropTypes.string),
  hyphenated: PropTypes.bool,
};

export default RichText;
